<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/residencia/fondo-residencia.jpg" style="background-image: url('assets/img/fondo-planmaestro.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Residencia - Proyecto IOARR
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-40 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/gerencia/fondo-gerencia.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">

          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/residencia/residenta.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">ARQ. Eliluz Palomino Mormontoy</h3>
                    <h6 class="designation mb-20" style="text-align: center;">RESIDENTA</h6>
                </div>
            </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="">
                  <h2>PROYECTO IOARR 2019 - 2021</h2>
                  <p class="m-0" style="font-size: 16px; line-height: 1.9;">Mediante el marco del Pan Maestro del Centro
                  Histórico del Cusco se tiene el proyecto IOARR “OPTIMIZACIÓN DEL SISTEMA DE INFORMACIÓN DEL SERVICIO DE
                  CATALOGACIÓN DE INMUEBLES DEL CENTRO HISTÓRICO, DISTRITO DE CUSCO, PROVINCIA CUSCO, DEPARTAMENTO CUSCO”,
                  el cual se viene ejecutando mediante componentes de desarrollo tales como el componente informático/GIS, componente
                  social, componente de verificación y componente de catalogación, quienes generaron la base de datos de la
                  catalogación de inmuebles y patrimonio inmaterial para la gestión de nuestro centro histórico, con el cual se
                  generó un portal web que se pondrá al servicio y consulta de la población en general respecto a la información
                  de valor patrimonial de inmuebles en el centro histórico que contiene fichas arquitectónicas, arqueológicas,
                  históricas y de patrimonio inmaterial.
                  </p>
              </div>
          </div>
      </div>
  </div>
</section>

<section id="landing-service-area-wrapper" class="pt-68 pt-md-26 pt-sm-20 pb-114 pb-md-76 pb-sm-56">
  <div class="container">

    <div class="row">
      <div class="col-lg-12 text-center" style="margin-bottom:-60px;">
        <div class="section-title-wrap">
          <h3 style="color:white">Funciones</h3>
        </div>
      </div>
      <!-- Single Service Item #1 -->
      <div class="col-md-6 col-lg-6">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>Residenta</h3>
            <p class="m-0">
              Dirigir, planificar, organizar y gestionar la óptima ejecución del proyecto de acuerdo a
              lo estipulado en el expediente técnico y la normativa vigente de inversión pública para
              ejecución por administración directa.
            </p>
          </div>
        </div>
      </div>
      <!-- Single Service Item #2 -->
      <div class="col-md-6 col-lg-6">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>Supervisor</h3>
            <p class="m-0">
              Inspecciona, revisa, controla y brinda asistencia técnica durante el proceso de ejecución del proyecto en
              cumplimiento del expediente técnico y la normativa vigente.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<section class="team-member-area pt-118 pt-md-80 pt-sm-60" style="background-image: url('/assets/img/fondo-equipo.png'); background-size: cover; background-position: center;">
  <div class="container" >
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-6 m-auto text-center">
        <div class="section-title-wrap layout--2">
          <h2>Equipo de trabajo</h2>
          <p class="mb-0">
            El personal que estuvo a cargo de la parte administrativa, coordinación y supervisión de cada componente fue integrado por los siguientes profesionales.
          </p>
        </div>
      </div>
      <!-- End Section title -->
    </div>
  </div>
</section>
<section class="team-member-area">
  <div class="team-content-wrapper d-flex flex-wrap mtm-30">
    <!-- Start Single Team Member -->

    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/residencia/miguel.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Arq. MIGUEL ANGEL VARGAS PULIDO</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Asistente Técnico</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/residencia/xiomara.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Arql. LISBETH XIOMARA AGUILAR ENRIQUEZ</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Almacenero</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/residencia/karen.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Tec. Adm. KAREN JUSELI LIMA ESPINOZA</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Auxiliar Administrativo</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member --><!-- Start Single Team Member -->
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/residencia/sr-palmiro.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Tec. Tmo. PALMIRO ERNESTO LEON PINO</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Asistente Administrativo 2</h5>
        </figcaption>
      </figure>
    </div>
    <div class="single-team-member-wrap">
      <figure class="team-member-pic">
        <img src="assets/img/residencia/prevencionista.jpg" alt="Team Member" />
        <figcaption class="member-info text-center">
          <h3 class="team-member-name">Br. Ing. Ind. KELLY FARFAN CASAVERDE</h3>
          <h5 class="team-member-desi" style="color:#FDC647;">Cargo: Prevencionista</h5>
        </figcaption>
      </figure>
    </div>
    <!-- End Single Team Member -->
  </div>
</section>

<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-40 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-rosario-2.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <div class="col-lg-6 text-center">
            <div class="">
                <h2>SUPERVISIÓN DE PROYECTO</h2>
                <p class="m-0" style="font-size: 16px; line-height: 1.9;">
                  Designado por la Dirección de Supervisión de Obras de la Municipalidad Provincial del Cusco,
                  revisa, controla, dirige y brinda asistencia técnica, así como se encarga del seguimiento en el desarrollo
                  del IOARR: “OPTIMIZACIÓN DEL SISTEMA DE INFORMACIÓN DEL SERVICIO DE CATALOGACIÓN DE INMUEBLES DEL CENTRO HISTÓRICO,
                  DISTRITO DE CUSCO, PROVINCIA CUSCO, DEPARTAMENTO CUSCO”, cumpliendo y haciendo cumplir las normativas aplicables,
                  verificando igualmente los tiempos y los trabajos realizados de cada uno de los componentes de la IOARR.
                </p>
            </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/residencia/supervisor.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">ARQ. JUAN ANTONIO SILVA DEL CARPIO</h3>
                    <h6 class="designation mb-20" style="text-align: center;">SUPERVISOR</h6>
                </div>
            </div>
          </div>
      </div>
  </div>
</section>

<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/residencia/ioarr-gch-01.jpg" class="btn-img-gallery">
                      <img src="assets/img/residencia/ioarr-gch-01.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-02.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-02.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/residencia/ioarr-gch-03.jpg" class="btn-img-gallery">
                      <img src="assets/img/residencia/ioarr-gch-03.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-04.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-04.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-08.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-08.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-05.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-05.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-06.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-06.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-07.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-07.jpg" alt="Portfolio">
                </a>
              </figure>

          </div>
      </div>
  </article>
</div>
